import { render, staticRenderFns } from "./chercher_et_classer.vue?vue&type=template&id=59c01960&scoped=true"
import script from "./chercher_et_classer.vue?vue&type=script&lang=js"
export * from "./chercher_et_classer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59c01960",
  null
  
)

export default component.exports